import { loadStripe } from '@stripe/stripe-js';

// Get Stripe publishable key from environment
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Check if key is valid (not placeholder)
const isValidStripeKey = stripePublishableKey && 
  stripePublishableKey !== 'pk_test_your_test_key_here' && 
  stripePublishableKey.startsWith('pk_');

// Initialize Stripe with publishable key only if valid
const stripePromise = isValidStripeKey ? loadStripe(stripePublishableKey) : null;

// For development, use a test key if none provided
// const developmentTestKey = 'pk_test_51HdSGkFZg6S9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x9x';

export default stripePromise;

// Stripe configuration
export const stripeConfig = {
  publishableKey: stripePublishableKey,
  isValidKey: isValidStripeKey,
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:6543',
  isDevelopment: process.env.REACT_APP_ENV === 'development'
};